export default __webpack_public_path__ + "static/media/home.2ccd61e5.png";